import React, { useEffect, createElement } from 'react';
import { AlertTriangle, Calendar, Phone, PlayCircle, CheckCircle2, Star, TrendingUp, ArrowRight } from 'lucide-react';
export function BookCallStrategyPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init + PageView handled globally in App.tsx — fire only
    // this page's unique event to avoid double-counting.
    if (window.fbq) {
      window.fbq('trackCustom', 'Book-Call-Confirmation');
    }
    // Load Vimeo player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://player.vimeo.com/api/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    return () => {
      if (document.head.contains(playerScript)) {
        document.head.removeChild(playerScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc]/20 selection:text-[#00f7fc]" data-id="element-529" data-mp="97oc8hhgxkgi">
      {/* Top Warning Banner */}
      <div className="w-full bg-red-600/20 border-b border-red-500/50" data-id="element-530" data-mp="9uhhazcqyvg">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-center gap-3 text-center" data-id="element-531" data-mp="2p0x3q2isqvx6">
          <AlertTriangle className="w-5 h-5 text-red-500 shrink-0 animate-pulse" data-id="element-532" data-mp="2kzjwbo022ko5" />
          <p className="text-sm md:text-base font-bold text-red-100" data-id="element-533" data-mp="2l1o8suc0ss01">
            Paso 1 de 2 completado. Tu llamada aún NO está confirmada.
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-534" data-mp="2resfq6wbaonv">
        {/* SECTION 1: HEADLINE */}
        <section className="text-center space-y-6 mb-12" data-id="element-535" data-mp="2ci1hi0ydjizu">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight" data-id="element-536" data-mp="2hgl2nz558qr5">
            <span className="text-red-500" data-id="element-537" data-mp="23ppt0kmtm5mi">⚠️ Importante:</span> Tu Sesión
            Estratégica con Gabriel Beltrán{' '}
            <span className="underline decoration-red-500" data-id="element-538" data-mp="28i93v9u4imnm">
              NO Está Confirmada Aún
            </span>
          </h1>
          <p className="text-base md:text-2xl text-gray-300 max-w-3xl mx-auto leading-snug md:leading-relaxed" data-id="element-539" data-mp="1tpyw6casfej9">
            Para confirmar tu llamada, completa los siguientes pasos. Te tomará
            menos de 3 minutos.
          </p>
        </section>

        {/* SECTION 2: MAIN VIDEO */}
        <section className="mb-16" data-id="element-540" data-mp="1outddmcomfze">
          <div className="relative max-w-3xl mx-auto" data-id="element-541" data-mp="163wm1egoe6qk">
            {/* Brand blue gradient shadow */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00f7fc] via-[#00d7dc] to-[#00f7fc] opacity-50 blur-xl rounded-2xl" data-id="element-542" data-mp="1163gmnn75grc"></div>

            <div className="relative bg-gray-900 border border-[#00f7fc]/50 rounded-2xl overflow-hidden shadow-2xl" data-id="element-543" data-mp="1f6e9txbzb7fo">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-544" data-mp="1a8cot6uzsy1k">
                <iframe src="https://player.vimeo.com/video/1173647975?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="FELICIDADES POR AGENDAR" data-id="element-545" data-mp="1k4fpe8a74ome"></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: NEXT STEPS */}
        <section className="mb-16" data-id="element-546" data-mp="2qy58yjs2q6vh">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-547" data-mp="2qx2gw8j0lydz">
            Tu Plan de Acción Inmediato{' '}
            <span className="text-[#00f7fc]" data-id="element-548" data-mp="2vpvk2ryu4yny">(Para Asegurar Tu Llamada)</span>:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-549" data-mp="30nez3u3cxfgy">
            {/* Step 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-550" data-mp="23zihclw6oe45">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-551" data-mp="27zsv4kq7w8tk">
                <PlayCircle className="w-6 h-6 text-[#00f7fc]" data-id="element-552" data-mp="2cxkqjoq2md2i" />
              </div>
              <div data-id="element-553" data-mp="2hxyx12c0xeyf">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-554" data-mp="2hyi2vkoegcw3">
                  1. Mira el video de arriba
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-555" data-mp="3ofvl2fq7trlj">
                  Es el paso más importante para alinear expectativas y asegurar
                  que saques el máximo provecho de nuestra llamada.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-556" data-mp="1csrzav2gigpi">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-557" data-mp="130m99qvrm9cy">
                <Calendar className="w-6 h-6 text-[#00f7fc]" data-id="element-558" data-mp="130cja3aq0279" />
              </div>
              <div data-id="element-559" data-mp="yzso359pj8nr">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-560" data-mp="ywxzr2nkp3p2">
                  2. AÑADE la cita a tu calendario
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-561" data-mp="p0bg2h6zgiom">
                  Busca un email nuestro con el asunto "Confirmación de tu
                  Sesión Estratégica". Ábrelo y haz clic en "Añadir al
                  Calendario". Un evento en tu calendario es un compromiso real.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-562" data-mp="cqlt93unoyd7">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-563" data-mp="hh27gq6awo0m">
                <Phone className="w-6 h-6 text-[#00f7fc]" data-id="element-564" data-mp="hjez5v1v2cqv" />
              </div>
              <div data-id="element-565" data-mp="2u0omjmjtp9w">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-566" data-mp="2qcvvmoxh6w8">
                  3. Espera la llamada de confirmación
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-567" data-mp="vgtrb7ji0ymj">
                  Un miembro de nuestro equipo te contactará en las próximas 24
                  horas para confirmar algunos detalles. (Por favor, contesta,
                  es parte del proceso).
                </p>
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-568" data-mp="qk3c0mfiq726">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-569" data-mp="3790g21rpbfwh">
                <CheckCircle2 className="w-6 h-6 text-[#00f7fc]" data-id="element-570" data-mp="3b9kd75c9yjim" />
              </div>
              <div data-id="element-571" data-mp="33nf35g0jdi1f">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-572" data-mp="33mvpibhx5ft7">
                  4. Prepárate para la sesión
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-573" data-mp="3dmmg423czao0">
                  Justo debajo, encontrarás una serie de videos cortos que
                  responden a las dudas más comunes. Verlos nos ahorrará tiempo
                  para ir directo a tu estrategia.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 4: IDENTITY RE-ANCHORING */}
        <section className="mb-16 max-w-3xl mx-auto" data-id="element-574" data-mp="2uojvdzhufzw0">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-575" data-mp="2uq4v03j0m90q">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#00f7fc] to-transparent" data-id="element-576" data-mp="226pgnjxw98cj"></div>

            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-577" data-mp="1x8e77abigzuu">
              Recuerda por qué agendaste esta llamada.
            </h2>

            <div className="space-y-4 text-gray-300 text-lg leading-relaxed" data-id="element-578" data-mp="1go63hj35vqn0">
              <p data-id="element-579" data-mp="1gq93mvy1305g">
                Lo hiciste porque sabes que seguir improvisando, probando
                tácticas sueltas y dependiendo de la suerte no es una estrategia
                de negocio.
              </p>
              <p data-id="element-580" data-mp="1uogvipg7jb9r">
                Agendaste porque estás listo para un sistema, para la claridad y
                para los resultados que tu esfuerzo realmente merece.
              </p>
              <p className="text-white font-bold text-xl mt-6" data-id="element-581" data-mp="24e0fxzjkjd6q">
                La versión de ti que agendó esta llamada quiere un cambio.
                Quiere pasar al siguiente nivel.{' '}
                <span className="text-[#00f7fc]" data-id="element-582" data-mp="29ewhi6gg6n8z">No la dejes esperando.</span>
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 5: OBJECTION HANDLING VIDEOS */}
        <section className="mb-20" data-id="element-583" data-mp="2ibf83c17hz2e">
          <div className="text-center mb-10" data-id="element-584" data-mp="6qohx7c4ox1w">
            <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-585" data-mp="6obr04oe7ccp">
              ¿Tienes Dudas?{' '}
              <span className="text-[#00f7fc]" data-id="element-586" data-mp="1tfxt17f6iy0">
                Las Resolvemos Antes de la Llamada:
              </span>
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-587" data-mp="3owkpvhxxnef6">
              Mira estos videos cortos para llegar 100% preparado.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-588" data-mp="pg4ke07dizky">
            {/* Video 1 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-589" data-mp="lhfawipgi26l">
              <div className="bg-gray-800 relative" data-id="element-590" data-mp="gmhugqpukqjo">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-591" data-mp="bogb04oiep7o">
                  <iframe src="https://player.vimeo.com/video/1173156247?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 1" data-id="element-592" data-mp="1967x3nga0vo0"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-593" data-mp="3ki3s7jbaucku">
                <p className="font-bold text-sm" data-id="element-594" data-mp="3kh2f79aq3g0h">
                  ¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?
                </p>
              </div>
            </div>

            {/* Video 2 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-595" data-mp="3u7n8ch7mnsc0">
              <div className="bg-gray-800 relative" data-id="element-596" data-mp="3p9vidsqjmgag">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-597" data-mp="72pcqu1sssr2">
                  <iframe src="https://player.vimeo.com/video/1173156261?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 2" data-id="element-598" data-mp="25yx27twnz66"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-599" data-mp="2xvasthobzxj">
                <p className="font-bold text-sm" data-id="element-600" data-mp="7rg80jbg0pvo">
                  Ya he invertido en otros programas y no me funcionaron. ¿Qué
                  hace a este diferente?
                </p>
              </div>
            </div>

            {/* Video 3 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-601" data-mp="3u3myznbw52hp">
              <div className="bg-gray-800 relative" data-id="element-602" data-mp="3l5b5ndjn3qlk">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-603" data-mp="3l4rq23hgpeap">
                  <iframe src="https://player.vimeo.com/video/1173156277?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VIDEO 3" data-id="element-604" data-mp="1qqxcxu0yqzmw"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-605" data-mp="20mh6wavyvo90">
                <p className="font-bold text-sm" data-id="element-606" data-mp="20lfkja9i3fbz">
                  No tengo tiempo para implementar otro sistema complejo.
                </p>
              </div>
            </div>

            {/* Video 4 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-607" data-mp="p60ny7l7ephe">
              <div className="bg-gray-800 relative" data-id="element-608" data-mp="kbd8ey86h5ey">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-609" data-mp="2vxf5hblzzvas">
                  <iframe src="https://player.vimeo.com/video/1173156217?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 4" data-id="element-610" data-mp="30voxjdcfefs6"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-611" data-mp="3smcwciqmn92o">
                <p className="font-bold text-sm" data-id="element-612" data-mp="3slbjc8q1wcib">
                  Me preocupa el costo de la inversión. ¿Cuál es el ROI real?
                </p>
              </div>
            </div>

            {/* Video 5 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-613" data-mp="1y8vkhszl40nh">
              <div className="bg-gray-800 relative" data-id="element-614" data-mp="130i6owl0acpw">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-615" data-mp="yxli8p8sbme1">
                  <iframe src="https://player.vimeo.com/video/1173156206?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 5" data-id="element-616" data-mp="1cw340hf4qotb"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-617" data-mp="1hg46sw622ql">
                <p className="font-bold text-sm" data-id="element-618" data-mp="1geh1q1vlpsi">
                  ¿No puedo simplemente hacer lo mismo con ChatGPT y otras
                  herramientas gratuitas?
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 6: SOCIAL PROOF */}
        <section className="mb-20" data-id="element-619" data-mp="2cxgkgkg3ryap">
          <div className="text-center mb-12" data-id="element-620" data-mp="2cyhx2tcrosuj">
            <div className="inline-flex items-center justify-center gap-2 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-6 py-2 mb-6" data-id="element-621" data-mp="1z5tchncst1c3">
              <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-622" data-mp="234iyg4bwjr7c" />
              <span className="text-yellow-500 font-bold tracking-wide uppercase text-sm" data-id="element-623" data-mp="2qxhlq10a57qp">
                Casos de Éxito
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-624" data-mp="2hvrt4runw2rc">
              Resultados Reales de Emprendedores que{' '}
              <span className="text-[#00f7fc]" data-id="element-625" data-mp="2mtjmzrev9yy6">Dejaron de Improvisar</span>
            </h2>
          </div>

          <div className="space-y-8" data-id="element-626" data-mp="16fjp0lzl0jdk">
            {/* Testimonial 1 (Video style) */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-8 items-center" data-id="element-627" data-mp="1bfpj08tbqhyt">
              <div className="w-full md:w-1/3 bg-gray-800 rounded-xl relative overflow-hidden shrink-0" data-id="element-628" data-mp="3d3trfxldh91i">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-629" data-mp="387ljp59i8i4d">
                  <iframe src="https://player.vimeo.com/video/1163416902?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Carwin Testimonial" data-id="element-630" data-mp="2zdglg0s1k4et"></iframe>
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-631" data-mp="in9t2nyt51r2">
                <div className="flex gap-1 mb-4" data-id="element-632" data-mp="emzmpa73s9bo">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-633" data-mp="ekv9g1nbdxyq" />)}
                </div>
                <p className="text-xl md:text-2xl text-gray-300 italic leading-relaxed mb-4" data-id="element-634" data-mp="1wirxk8dqpja5">
                  "Pasé de repartir pizzas a generar $100,000 en un solo día. No
                  fue un golpe de suerte, fue seguir el sistema HEYLLOYD al pie
                  de la letra, sin desviarme."
                </p>
                <p className="font-bold text-white" data-id="element-635" data-mp="1dm04j78ebpsw">— Carwin M.</p>
              </div>
            </div>

            {/* Testimonial 2 (Text + Image) */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-636" data-mp="1ild14jp2kb8o">
              <div className="w-full md:w-1/3 bg-gray-800 rounded-xl relative overflow-hidden shrink-0" data-id="element-637" data-mp="1rl9lwa8c8pyg">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-638" data-mp="2y1tyi7mxll7c">
                  <iframe src="https://player.vimeo.com/video/1163771829?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="David Moreno TM Academy" data-id="element-639" data-mp="32zn87ang0xcd"></iframe>
                </div>
              </div>
              <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-640" data-mp="2xgfblukbzwcb">
                <div className="flex gap-1 mb-4 justify-center md:justify-start" data-id="element-641" data-mp="2seztaa9jg3xm">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-642" data-mp="36ehgwmb3lb5e" />)}
                </div>
                <p className="text-xl md:text-2xl text-gray-300 italic leading-relaxed mb-4" data-id="element-643" data-mp="32bkz2xtdtj2i">
                  "Estaba estancado, sin dinero para invertir en mi propia
                  academia. Después de implementar el sistema, generamos más de
                  $3,000,000. El sistema te da la confianza para escalar porque
                  sabes que funciona."
                </p>
                <p className="font-bold text-white" data-id="element-644" data-mp="11wjcc2lh8r4z">— David M.</p>
              </div>
            </div>

            {/* Testimonial 3 (Screenshot) */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8" data-id="element-645" data-mp="t4hjoqhngf59">
              <div className="flex flex-col items-center text-center" data-id="element-646" data-mp="e80941hab4jr">
                <div className="w-full max-w-2xl bg-gray-800 rounded-xl mb-6 overflow-hidden border border-gray-700" data-id="element-647" data-mp="ea35r4cxzvxg">
                  <div style={{
                  position: 'relative'
                }} data-id="element-648" data-mp="57bqsukuyi12">
                    <video src="https://player.vimeo.com/progressive_redirect/playback/1175309646/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=413dc55fa799003dfa8f621119e11a716380945144d6f5c88b0538d0da138778" controls playsInline preload="metadata" style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    borderRadius: '0.75rem'
                  }} title="Recap Zoom Calls + Testimonios" data-id="element-649" data-mp="a657swzcsr5z"></video>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-650" data-mp="2y77qzvv7ympz">
                  Resultados de alumnos de 48/HR AI Cash Machine
                </h3>
                <p className="text-gray-400 max-w-2xl leading-relaxed" data-id="element-651" data-mp="3quu1zp6s0tmv">
                  "Testimonios reales de alumnos que implementaron el sistema y
                  obtuvieron resultados medibles en tiempo récord."
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 7: FINAL CTA */}
        <section className="text-center max-w-3xl mx-auto bg-gradient-to-b from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12" data-id="element-652" data-mp="3lufse2pj1bmq">
          <h2 className="text-2xl md:text-4xl font-black mb-6 leading-tight" data-id="element-653" data-mp="26hcv1gcuvysc">
            Tu Negocio del Futuro Depende de las Decisiones que Tomas Hoy
          </h2>

          <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-654" data-mp="22vhydor8oq01">
            Has tomado la decisión correcta al agendar esta llamada. Ahora,
            completa el proceso. Confirma tu cita en el calendario, prepárate
            para la sesión y llega listo para diseñar tu plan de escalamiento.
          </p>

          <p className="text-xl font-bold text-[#00f7fc] mb-8" data-id="element-655" data-mp="27u2ubbzgknio">
            Estamos ansiosos por mostrarte lo que es posible.
          </p>

          <p className="text-gray-400 font-medium italic" data-id="element-656" data-mp="1f8085xnmhzz6">
            - Gabriel Beltrán y el Equipo de HEYLLOYD
          </p>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12 mt-12" data-id="element-657" data-mp="1p5o7z2035xo7">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-658" data-mp="1p3tkbfxfjrgf">
          <div className="mb-6" data-id="element-659" data-mp="11esiwcn0lgkn">
            <p className="text-[#00f7fc] font-bold text-lg md:text-xl mb-2" data-id="element-660" data-mp="11dzbrak58p1z">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-661" data-mp="1m5xsr0c7tw7u">
            <p data-id="element-662" data-mp="1q67we6cjcajj">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500" data-id="element-663" data-mp="1uxzoilbcaobs">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-664" data-mp="1zwstfpck970c">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}